import Card from "./card"
import {Cycle} from "./cycle"
import {ReactComponent as PreviousIcon} from "../assets/icons/prev_icon.svg"
import {ReactComponent as NextIcon} from "../assets/icons/next_icon.svg"
import {IconButton} from "./buttons"

export function SplitLayout({hasDetailResource, leftPaneClassName, isHidingLeftPane, toggleLeftPane, rightPaneClassName, isHidingRightPane, toggleRightPane, cycleDatasource, showHideButtons, ...props}) {
  return (
    <div className="split-layout">
      <LeftPane className={leftPaneClassName} isHidingLeftPane={isHidingLeftPane} toggleLeftPane={toggleLeftPane}>
        {props.children[0]}
      </LeftPane>
      <div className="split-layout-center">
        <div>
          {props.children[1]}
        </div>
      </div>
      <RightPane
        className={rightPaneClassName}
        hasDetailResource={hasDetailResource}
        isHidingRightPane={isHidingRightPane}
        toggleRightPane={toggleRightPane}
        showHideButton={showHideButtons}
        cycleDatasource={cycleDatasource}
      >
        {props.children[2]}
      </RightPane>
    </div>
  )
}

function LeftPane({isHidingLeftPane, toggleLeftPane, ...props}) {
  const {className, ...rest} = props
  const icon = isHidingLeftPane ? <NextIcon/> : <PreviousIcon/>
  return (
    <div className={`split-layout-pane ${className || ""} left`} {...rest}>
      <Card aria-hidden={isHidingLeftPane}>
        {props.children}
      </Card>

      <ButtonLayout onClick={toggleLeftPane}>
        {icon}
      </ButtonLayout>
    </div>
  )
}

function RightPane({hasDetailResource, isHidingRightPane, toggleRightPane, showHideButton, cycleDatasource, ...props}) {
  const {className, ...rest} = props

  if (showHideButton == null) {
    showHideButton = hasDetailResource
  }

  const icon = isHidingRightPane ? <PreviousIcon/> : <NextIcon/>

  return (
    <div className={`split-layout-pane ${className || ""} right`} {...rest}>
      <Card aria-hidden={isHidingRightPane}>
        {cycleDatasource != null && <div className="wireless-config-overlay-right-pane-ap-header">
          <Cycle datasource={cycleDatasource}/>
        </div>}

        {props.children}
      </Card>

      <ButtonLayout show={showHideButton} onClick={toggleRightPane}>
        {icon}
      </ButtonLayout>
    </div>
  )
}

function ButtonLayout({show = true, onClick, ...props}) {
  if (!show) {
    return null
  }

  return (
    <div className="split-layout-pane-button">
      <IconButton variant="secondary" onClick={onClick}>
        {props.children}
      </IconButton>
    </div>
  )
}